( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('SingleDblClickService', SingleDblClickService);

    SingleDblClickService.$inject = ['$rootScope', '$timeout','$uibModal','FreightPayment','Controller'];

    function SingleDblClickService($rootScope, $timeout, $uibModal, FreightPayment, Controller) {
        return {
            rowTemplate: rowTemplate,
            singleClick: singleClick,
            singleClickDTO: singleClickDTO,
            dblClick: dblClick,
            dblClickAgent: dblClickAgent,
            dblClickDTO: dblClickDTO,
            dblClickModal: dblClickModal
        };

        function rowTemplate() {
            return '<div ng-click="grid.appScope.rowSingleClick(row)" ng-dblclick="grid.appScope.rowDblClick(row)" >' +
                ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
                ' class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"  ui-grid-cell></div>' +
                '</div>';
        }

        function singleClick(row, route, type) {
            if ($rootScope.clicked) {
                $rootScope.cancelClick = true;
                return;
            }
            $rootScope.clicked = true;
            $timeout(function () {
                if ($rootScope.cancelClick) {
                    $rootScope.cancelClick = false;
                    $rootScope.clicked = false;
                    return;
                }
                //action
                var data = {
                    heading: 'Detail ' + returnHeading(row, type),
                    route: route,
                    id: row.entity.id,
                    param: {id: ''}
                };
                if (data.id > 0) {
                    $rootScope.$emit('handleEmit', data);
                }
                //clean up
                $rootScope.cancelClick = false;
                $rootScope.clicked = false;
            }, 500);
        }

        function singleClickDTO(row, route, type) {
            if($rootScope.clicked) {
                $rootScope.cancelClick = true;
                return;
            }
            $rootScope.clicked = true;
            $timeout(function() {
                if($rootScope.cancelClick) {
                    $rootScope.cancelClick = false;
                    $rootScope.clicked = false;
                    return;
                }
                //action
                var data = {
                    heading: 'Detail ' + returnHeadingDTO(row, type),
                    route: route,
                    id: returnIdDTO(row, type),
                    param: {id:''}
                };
                if(data.id > 0) {
                    $rootScope.$emit('handleEmit', data);
                }
                //cleanup
                $rootScope.cancelClick = false;
                $rootScope.clicked = false;
            }, 500);
        }

        function dblClick(row, route, type) {
            var data = {
                heading: 'Edit ' + returnHeading(row, type),
                route: route,
                id: row.entity.id,
                param: {id: ''}
            };
            if (data.id > 0) {
                $rootScope.$emit('handleEmit', data);
            }
        }

        function dblClickAgent(row, route, type) {
            var data = {
                heading: 'Detail ' + returnHeading(row, type),
                route: route,
                id: row.entity.id,
                param: {id: ''}
            };
            if(data.id > 0) {
                $rootScope.$emit('handleEmit', data);
            }
        }

        function dblClickDTO(row, route, type) {
            var data = {
                heading: 'Edit ' + returnHeadingDTO(row, type),
                route: route,
                id: returnIdDTO(row, type),
                param: {id: ''}
            };
            if(data.id > 0) {
                $rootScope.$emit('handleEmit', data);
            }
        }

        function dblClickModal(row, type) {
            switch(type) {
                case "fp":
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                        controller: 'FreightPaymentDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return FreightPayment.get({id:row.entity.id}).$promise;
                            },
                            translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('freight-payment');
                                $translatePartialLoader.addPart('currencyType');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    });
                    return modalInstance;
                case "controller":
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/controller/controller-dialog.html',
                        controller: 'ControllerDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return Controller.get({id:row.entity.id}).$promise;
                            },
                            translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('controller');
                                $translatePartialLoader.addPart('currencyType');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    });
                    return modalInstance;
            }
        }

        function returnHeading(row, type) {
            switch (type) {
            case 'contract':
                return row.entity.contractNum;
            case 'shipment':
                return row.entity.shipmentNum;
            case 'invoice':
                return row.entity.invoiceNum;
            case 'lot':
                return row.entity.lotRef;
            case 'formula':
                return row.entity.label;
            case 'fp':
                return row.entity.blNumber;
            case 'controller':
                return row.entity.shipment;
            }
        }

        function returnHeadingDTO(row, type) {
            switch(type) {
                case 'fixation-management':
                    return row.entity.contractNum;
            }
        }

        function returnIdDTO(row, type) {
            switch(type) {
                case 'fixation-management':
                    return row.entity.contractId;
            }
        }
    }
})();
